'use client'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { formatPrice } from '@/lib/utils'
import { ProductPromotion } from '@/types/product-detail'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import Link from 'next/link'

type Props = {
  product: ProductPromotion
}

export const ProductPromotionItem = ({ product }: Props) => {
  const t = useTranslations()

  return (
    <div className='flex h-full gap-4 overflow-visible'>
      <div className='relative w-1/3 overflow-hidden rounded-lg'>
        <Image
          src={ImageHelper.getImageUrl(product.images[0]?.src, 'xs')}
          alt={product.title}
          width={150}
          height={200}
          className='aspect-auto h-full w-full rounded-lg object-cover'
        />
        {product.compare_price > product.regular_price && (
          <div className='absolute right-1 top-1 flex'>
            <span className='rounded-sm bg-gradient-to-r from-[#273BCD] to-[#1C2B9D] p-0.5 px-1 py-[1px] text-[10px] font-semibold text-white'>
              -
              {Math.round(
                ((product.compare_price - product.regular_price) /
                  product.compare_price) *
                  100
              )}
              %
            </span>
          </div>
        )}
      </div>
      <div className='w-2/3'>
        <Link
          href={`/product/${product.seo_alias}`}
          className='line-clamp-2 font-sans text-base text-neutral-800'
        >
          {product.title}
        </Link>
        <div className='mt-2 text-sm italic leading-tight text-neutral-800'>
          {product.description || t('cart_page.title.featured_products')}
        </div>
        <div className='mt-1 font-sans text-base font-bold text-neutral-800'>
          <span>{formatPrice(product.regular_price)} </span>
          <del className='ml-1 font-medium text-gray-300'>
            {formatPrice(product.compare_price)}
          </del>
        </div>
      </div>
    </div>
  )
}
